import React, {useEffect} from 'react';
import {useStyles} from "./TopupProducts.style";
import {Observer} from "mobx-react-lite";
import MessageCard from "../../ui_components/MessageCard/MessageCard";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import {useCommonContext} from "../../contexts/CommonContext";
import TopupProductStore from './TopupProductsStore';
import TopupProductRow from './TopupProductsRow/TopupProductsRow';


const TopupProducts: React.FC = () => {
    const commonStore = useCommonContext();
    const topupProductStore = new TopupProductStore(commonStore);
    const classes = useStyles();

    useEffect(() => {
        topupProductStore.getElements();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onUpdate = async () => {
        await topupProductStore.getElements();
    }

    return (
        <Observer>
            {() => (
                <div className={classes.topup_price_container}>
                    {!topupProductStore.isEmpty &&
                    <div className={classes.topup_price_table}>
                        <div className={classes.elements_container}>
                            {topupProductStore.products.map((product, i) => (
                                <TopupProductRow
                                    onUpdate={onUpdate}
                                    topupProduct={product}
                                    key={i}
                                />
                            ))}
                        </div>
                    </div>}
                    {topupProductStore.isEmpty &&
                    <MessageCard icon={CurrencyExchangeIcon} title={'No hay productos de recargas!!!'}
                                 subtitle={'Utiliza la barra superior para crear un nuevo producto de recarga'}/>}
                </div>
            )}
        </Observer>
    )
}

export default TopupProducts;
